<template>
  <div id="app">
    <!-- <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>-->
    <router-view></router-view>
    <p style="opacity: 0; height: 0; width: 0; overflow: hidden;">Pipeline migration test</p>
  </div>
</template>

<script>
export default {
  name: "App",
  watch: {
    $route: {
      handler: function(val, oldVal) {
        this.$store.state.urlParam = this.$utils.getUrlParam();
        this.$nextTick(() => {
          if ((this.$route.name == 'processInfo' || this.$route.name == 'iframeForm' || this.$route.name == 'readingLog') && this.$utils.isPC()) {
            this.switchBgc();
          }
        });
        if(this.$route.name=='onlyReadProcessInfo'){
          this.$store.state.onlyReadHide = false
        }
      },
      // 深度观察监听
      deep: true
    },
    '$store.state.isPadding':function(){
      if ((this.$route.name == 'processInfo' || this.$route.name == 'iframeForm' || this.$route.name == 'readingLog') && this.$utils.isPC()) {
            this.switchBgc();
          }
    }
  },
  methods: {
    sum(x,y){
      return x+y;
    },
    // 设置背景色
    switchBgc() {
      const color = this.$store.state.isPadding ? '#f5f5f5' : '#fff';
      const eHtml = document.getElementsByTagName('html')[0];
      eHtml.style.cssText = `${eHtml.style.cssText};background: ${color}`;
      document.body.style.cssText = `background: ${color}`;
      document.getElementById('app').style.cssText = `background: ${color}`;
    },
  },
   beforeCreate: function() {
    //在移动端设置cookies
    let isPc = this.$utils.isPC();
    // if (!isPc) {
      let urlParam = this.$utils.getUrlParam();
      let exp = new Date();

      exp.setTime(exp.getTime() + 11* 60 * 60 * 1000); //过期时间;
      if (urlParam.token != undefined) {
        if(!isPc){
          document.cookie =
          "CASTGC=" +
          urlParam.token  +
          ";expires=" +
          exp.toGMTString()
          +";domain=.platanus.com;path=/";

         document.cookie =
          "CASTGC=" +
          urlParam.token+
           ";expires=" +
          exp.toGMTString()
        }else{

          if(window.location.host.indexOf('platanus.com')>-1||window.location.host.indexOf('bpm3sit')>-1||window.location.host.indexOf('bpm3stest')>-1){
            document.cookie =
          "CASTGC=" +
          urlParam.token  +
          ";expires=" +
          exp.toGMTString()
          +";domain=.platanus.com;path=/";

            document.cookie =
          "CASTGC=" +
          urlParam.token  +
          ";expires=" +
          exp.toGMTString()
          +";domain=.platanus.com;path=/";

          document.cookie =
          "CASTGC=" +
          urlParam.token  +
          ";expires=" +
          exp.toGMTString()
          +";domain=.platanus.com;path=/";
          }
          if(window.location.host.indexOf('longfor.uat')>-1||window.location.host.indexOf('bpm3uat')>-1||window.location.host.indexOf('bpm3suat')>-1){
             document.cookie =
          "CASTGC=" +
          urlParam.token  +
          ";expires=" +
          exp.toGMTString()
          +";domain=.longfor.uat;path=/";

             document.cookie =
          "CASTGC=" +
          urlParam.token  +
          ";expires=" +
          exp.toGMTString()
          +";domain=.platanus.com;path=/";

          document.cookie =
          "CASTGC=" +
          urlParam.token  +
          ";expires=" +
          exp.toGMTString()
          +";domain=.platanus.com;path=/";
          }
          if(window.location.host.indexOf('bpm3pre')>-1){
             document.cookie =
          "CASTGC=" +
          urlParam.token  +
          ";expires=" +
          exp.toGMTString()
          +";domain=.platanus.com;path=/";

             document.cookie =
          "CASTGC=" +
          urlParam.token  +
          ";expires=" +
          exp.toGMTString()
          +";domain=.platanus.com;path=/";
          }
          if(window.location.host.indexOf('bpm3.platanus.com')>-1){
              document.cookie =
          "CASTGC=" +
          urlParam.token  +
          ";expires=" +
          exp.toGMTString()
          +";domain=.platanus.com;path=/";

              document.cookie =
          "CASTGC=" +
          urlParam.token  +
          ";expires=" +
          exp.toGMTString()
          +";domain=.platanus.com;path=/";
          }
        }
      }
    // }
  },
  created(){
    let userAgent = navigator.userAgent; //获取UA信息
    let defaultEnv = 'YTS';
    this.$store.state.isLongforShuanghu =
      userAgent.indexOf("com.longfor.ecloud") > -1 ||
      userAgent.indexOf("com.longfor.unixinapp") > -1 ||
      userAgent.indexOf("kuaiyixing.CheYiXing") > -1 ||
      userAgent.indexOf("LFWC") > -1 ||
      userAgent.indexOf("yuntusuo") > -1 ||
      defaultEnv === 'YTS';
    this.$store.state.ssoToken = this.$utils.getUrlParam().token;

    // 是否是在云图梭web端打开的
    let runEnv = this.$utils.getUrlParam().runEnv;
      console.log("当前环境",runEnv);
    // 等云图梭的修改上线后--删除
    if(runEnv){
      if(runEnv==="YTS" || runEnv==="YTSOUT"){
        this.$store.state.IS_IN_YTS_WEB = runEnv==="YTS";// 是否是在云图梭web端工作台中打开的
        this.$store.state.IS_IN_YTS_WEB_OUT = runEnv==="YTSOUT"; // 是否是在云图梭web端待办中打开的
      }else{
        this.$store.state.BPM_FROM_ENV = runEnv;
        this.$store.state.IS_IN_YTS_WEB = runEnv==="TODO_WEB_IN" || runEnv==="YTS_WEB_IN";
      }
    }
  },
  mounted() {
    if (this.$utils.isIE()) {
      // IE路由改变页面不刷新
      window.addEventListener(
        "hashchange",
        () => {
          let currentPath = window.location.hash.slice(1);
          if (this.$route.path !== currentPath) {
            this.$router.push(currentPath).catch(err => {});
          }
        },
        false
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/App.vue